import componentFn from '../../styles/objects/component'
import { CONTEXT_ROOT } from '../../utils'

const assetsPath = `${CONTEXT_ROOT}/assets`

export default ({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
}) => {

    const component = componentFn({
        colors,
        spacings,
        images,
        fontFamilies,
        fontWeights,
        fontSizes,
        textTransforms
    })

    const styles = {
        // 'tariffe-component':{
        //     width: '14rem!important'
        // },
        'tariffe': {
            width: '20rem',//13rem',
            position: 'relative'
        },
        'tariffe-block': {
            // textAlign: 'center',
            border: '2px solid',
            padding: '2rem 5rem',//'1.5rem 2rem',
            borderRadius: '5px',
            cursor: 'pointer'
        },
        'tariffe-block-selected':{
            borderColor: colors.input.border.active
        },
        'tariffe-selected': {
            color: colors.label.default
        },
        'tariffe-selected-img': {
            // backgroundImage: 'url(/assets/images/sella_it_logo.svg)',
            backgroundImage: `url('${assetsPath}/images/select_tick.svg')`,
            position: 'absolute',
            width: '2rem',
            height: '2rem',
            backgroundRepeat: 'no-repeat',
            top: '-0.7rem',
            right: '-0.85rem'
        },
        'tariffe-block-disabled':{
            // borderColor: colors.input.border.default
            borderColor: '#cecece'
        },
        'tariffe-disabled': {
            // color: colors.label.disabled
            color: '#cecece'
        },
        'tariffe-currency-vat': {

        },
        'tariffe-currency': {
            display: 'inline-block',
            fontSize: '4rem',
            fontWeight: '900'
        },
        'tariffe-vat': {
            display: 'inline-block',
            position: 'absolute',
            marginTop: '2rem',
            fontSize: '0.8rem',
            fontWeight: '900',
            marginLeft: '0.5rem'
        },
        'tariffe-per-month': {
            textAlign: 'center'
        },
        'tariffe-desc': {
            marginTop: '0.5rem',
            //fontSize: '0.9rem'
        },
        "tariffe-link": {
            textDecoration: "underline",
            color: "#4285f4",
            fontWeight: "600",
            cursor: "pointer"
        },
        "tariffe-hide":{
            display:'none'
        }

    }

    return { ...component, ...styles }
}


// WEBPACK FOOTER //
// ./components/tariffe/styles.js